import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { genericAPIs, reviewsAPI } from '../../services/api';
import { Review, ReviewModel, Skill } from '../../types';
import toast from 'react-hot-toast';

interface GenericState {
  skills: Skill[]
  loading: boolean;
  error: string | null;
}

const initialState: GenericState = {
  skills: [],
  loading: false,
error: null,
};

// Async thunks
export const fetchUserRoleSKills = createAsyncThunk(
  'skills',
  async (role: string, { rejectWithValue }) => {
    try {
      const response = await genericAPIs.getUserRoleSkills(role)
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch skills');
    }
  }
);

const genericSlice = createSlice({
  name: 'generic',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      // Fetch user reviews
      .addCase(fetchUserRoleSKills.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserRoleSKills.fulfilled, (state, action) => {
        state.loading = false;
        state.skills = action.payload.skills;
        

      })
      .addCase(fetchUserRoleSKills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        toast.error('Failed to load reviews');
    })
    
  },
});

// export const {  } = genericSlice.actions;
export default genericSlice.reducer;
